export default __webpack_public_path__ + "static/media/chevron.d7ed4ddb.svg";